// extracted by mini-css-extract-plugin
export default {"loginModal":"LoginModal_loginModal__KlzSH","dialog":"LoginModal_dialog__-An6z","cancelButton":"LoginModal_cancelButton__gKxXh"};